export const ADMIN_ADDRESS = "FC8dTSyxyRCJEEQ5iZFMgeLNryQhSiYUAAkHan1wkNcP";
export const PROJECT_VAULT_ADDRESS = "AbrQQtNEqrXG6baWCDbmymnEvi8JMZ9iP4nktEbzoZbc";
export const SOL = "solana";
export const USDC = "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v";
export const PHANTOM_APP_ID = "7982c7d8-12a9-4969-9320-df36e975c43b";
export const PROD_AUTH_PROVIDER = "phantom_app";